import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/pointer-black-thick.svg'


const _withScopeId = n => (_pushScopeId("data-v-36d3f1cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cookies-container"
}
const _hoisted_2 = { class: "sticky-disclaimer__container" }
const _hoisted_3 = { class: "sticky-disclaimer__text" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cookies = _resolveComponent("Cookies")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sticky-disclaimer", { short: !_ctx.showLongDisclaimer }])
  }, [
    (!_ctx.isDetectedMobileDevice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Cookies)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["sticky-disclaimer__wrapper", { short: !_ctx.showLongDisclaimer }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.showLongDisclaimer)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.line1`)), 1))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, [
            (!_ctx.isMobile || _ctx.showLongDisclaimer)
              ? (_openBlock(), _createElementBlock("strong", _hoisted_5, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.line2`)), 1))
              : (_openBlock(), _createElementBlock("strong", _hoisted_6, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.line2-short`)), 1))
          ]),
          (_ctx.showLongDisclaimer)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.line3`)), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["sticky-disclaimer__close", { rotate: !_ctx.showLongDisclaimer }])
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "sticky-disclaimer__toggle",
            tabindex: "-1",
            "aria-label": "Toggle disclaimer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDisclaimer && _ctx.handleDisclaimer(...args)))
          }, _hoisted_9)
        ], 2)
      ])
    ], 2)
  ], 2))
}